export function allIds(state, action) {
  const { containers } = action.payload;

  const newIds = containers.filter(c => state.indexOf(c.containerId) === -1)
    .map(c => c.containerId);

  return [...state, ...newIds];
}

export function byId(state, action) {
  const { containers } = action.payload;

  const newContainers = {};
  containers.forEach((c) => {
    newContainers[c.containerId] = c;
  });

  return { ...state, ...newContainers };
}
